var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"d-flex justify-content-center h-100 p-4"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }